import { Texture, Vec3 } from 'ogl';

export class Controller {
  mouseTarget = new Vec3();

  mousePos = new Vec3();

  deviceOrientation = new Vec3();

  constructor() {
    this.bind();
  }

  bind() {
    window.addEventListener('pointermove', this.movemouse.bind(this));
    window.addEventListener('pointerdown', this.downmouse.bind(this));
    window.addEventListener('pointerup', this.upmouse.bind(this));
    window.addEventListener(
      'deviceorientation',
      this.setOrientation.bind(this)
    );
  }

  unbind() {
    window.removeEventListener('pointermove', this.movemouse.bind(this));
    window.removeEventListener('pointerdown', this.downmouse.bind(this));
    window.removeEventListener('pointerup', this.upmouse.bind(this));
    window.removeEventListener(
      'deviceorientation',
      this.setOrientation.bind(this)
    );
  }

  movemouse(e: PointerEvent) {
    this.mouseTarget.x = e.x / window.innerWidth;
    this.mouseTarget.y = e.y / window.innerHeight;
  }

  upmouse() {
    this.mouseTarget.z = 1;
  }

  downmouse() {
    this.mouseTarget.z = 2;
  }

  setOrientation({ alpha, beta, gamma }) {
    this.deviceOrientation.x = alpha;
    this.deviceOrientation.y = beta;
    this.deviceOrientation.z = gamma;
  }

  update() {
    this.mousePos.x += (this.mouseTarget.x - this.mousePos.x) / 24;
    this.mousePos.y += (this.mouseTarget.y - this.mousePos.y) / 24;
    this.mousePos.z += (this.mouseTarget.z - this.mousePos.z) / 24;
  }
}

export function easeInOutSine(t) {
  return -0.5 * (Math.cos(Math.PI * t) - 1);
}

export function loadTexture(
  gl,
  path,
  options = {
    generateMipmaps: false,
    width: 2048,
    height: 2048,
    wrapS: gl.MIRRORED_REPEAT,
    wrapT: gl.MIRRORED_REPEAT,
  }
) {
  const texture = new Texture(gl, options);
  const img1 = new Image();
  img1.src = path;
  img1.onload = () => {
    texture.image = img1;
  };
  return texture;
}
